// Selectors variables to replace
let cart_icon = '.cart-link';
let cart_count = '.cart-link__count';

// Cart drawer
let $openCart, $closeCart, $cart, $overlay, $quantityInputs, $quantityButtons, $removeButtons;
let $html = document.querySelector('html');
let $body = document.querySelector('body');
document.addEventListener("DOMContentLoaded", function () {
  bindEvents();
 refreshUpsellSlider();
});

function refreshUpsellSlider() {
    // Check if slider is initialized
    if ($('.cart-upsell__list').hasClass('slick-initialized')) {
        // Destroy the existing slider
        $('.cart-upsell__list').slick('unslick');
    }
    
    // Reinitialize the slider
    const numberofSlide = parseInt($(".cart-upsell__list").data("size"),10);
  
    if(numberofSlide > 1){
      $('.cart-upsell__list').slick({
          infinite: false,
          arrows: true,
          slidesToShow: 1,
          prevArrow: `<button type="button" class="slick-prev slick-arrow"><svg width="78" height="130" viewBox="0 0 78 130" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M78 116.837L64.8781 130L0 64.9999L64.8781 0L78 13.1625L26.2844 64.9999L78 116.837Z" fill="black"/></svg></button>`,
          nextArrow: `<button type="button" class="slick-next slick-arrow"><svg width="78" height="130" viewBox="0 0 78 130" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 13.1625L13.1219 0L78 64.9999L13.1219 130L0 116.837L51.7156 64.9999L0 13.1625Z" fill="black"/></svg></button>`
      });
    }
    
}

// Custom events
document.addEventListener('cart:open', openCart);
document.addEventListener('cart:close', closeCart);
// Trigger a custom event : document.dispatchEvent(new CustomEvent('cart:open'))

document.addEventListener('cart:add', function (e) {
  let formData = e.detail.data;
  formData.sections = "cart-drawer";
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).then(response => {
    response.json().then(async data => {
      await window.refreshCart(data);
      openCart();
    });
  }).catch(error => {
    console.error('Error:', error);
  });
});

function bindEvents() {
  $openCart = document.querySelector(cart_icon);
  $closeCart = document.querySelector('.cart-drawer__close');
  $cart = document.querySelector('.cart-drawer');
  $overlay = document.querySelector('.cart-drawer-overlay');
  $quantityInputs = document.querySelectorAll('.cart-drawer .quantity-selector__input');
  $quantityButtons = document.querySelectorAll('.cart-drawer .quantity-selector__button');
  $removeButtons = document.querySelectorAll('.cart-item__remove-item');
  $openCart.addEventListener('click', function (e) {
    e.preventDefault();
    openCart();
  });
  $closeCart.addEventListener('click', function (e) {
    e.preventDefault();
    closeCart();
  });
  $overlay.addEventListener('click', function (e) {
    e.preventDefault();
    closeCart();
  });

  // Cart quantity selector
  $quantityInputs.forEach(function (elem) {
    elem.addEventListener('change', async function () {
      let value = parseInt(this.value);
      let variantId = this.closest('.cart-item').getAttribute('data-variant-id');
      let lineId = this.closest('.cart-item').getAttribute('data-line-id');

      // Remove item and linked items when setting quantity to 0
      if (value == 0) {
        await removeItem(variantId, lineId);
        return;
      }
      let changeData = {
        'id': variantId,
        'quantity': value,
        'sections': 'cart-drawer'
      };
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(changeData)
      }).then(response => {
        response.json().then(async data => {
          await window.refreshCart(data);
        });
      }).catch(error => {
        console.error('Error:', error);
      });
    });
  });

  // Quantity minus and plus click
  $quantityButtons.forEach(function (elem) {
    elem.addEventListener('click', function () {
      let currentInput = this.closest('.quantity-selector').querySelector('input');
      $cart.classList.add('is-loading');
      if (this.classList.contains('quantity-selector__minus')) {
        currentInput.stepDown();
      } else if (this.classList.contains('quantity-selector__plus')) {
        currentInput.stepUp();
      }

      if (this.getAttribute("data-item-remove-bundle")) {
         removeBundle(this.getAttribute("data-item-remove-bundle"));
      }

      // Trigger input change event
      var event = new Event('change');
      currentInput.dispatchEvent(event);
    });
  });

  // Remove buttons

  $removeButtons.forEach(function (elem) {
    elem.addEventListener('click', async function () {
      $cart.classList.add('is-loading');
      let variantId = this.closest('.cart-item').getAttribute('data-variant-id');
      let lineId = this.closest('.cart-item').getAttribute('data-line-id');

      if (this.getAttribute("data-item-remove-bundle")) {
        await removeBundle(this.getAttribute("data-item-remove-bundle"));
      } else {
        await removeItem(variantId, lineId);
      }
    });
  });
}

async function removeBundle(bundleId) {
  const data = await getCart();
  let updateData = {
    updates: {},
    sections: "cart-drawer"
  };

  let BundleItems = data.items.filter(function (item) {
     return item.properties !== null && (item.properties['_bundleId'] === parseInt(bundleId) || item.properties['_customBundleId'] === parseInt(bundleId));
  }).map(item => item.key);


  BundleItems.forEach(function (itemKey) {
    updateData.updates[itemKey] = 0;
  });

  await updateCart(updateData)
}

async function removeItem(variantId, lineId) {
  const data = await getCart();

  let updateData = {
    updates: {
      [lineId]: 0
    },
    sections: "cart-drawer"
  };

  // Get associated items id and pass it to the data
  let linkedItems = data.items.filter(function (item) {
    return item.properties !== null && item.properties['_linkedVariant'] == variantId;
  }).map(item => item.key);
  linkedItems.forEach(function (itemKey) {
    updateData.updates[itemKey] = 0;
  });

  // Remove all items if only upsell products left
  let nonLinkedItems = data.items.filter(function (item) {
    return item.id !== parseInt(variantId) && !linkedItems.includes(item.id);
  });

  if (nonLinkedItems.length > 0) {
    let allUpsell = nonLinkedItems.every(item => item.properties && item.properties['_upsell'] === true);

    if (allUpsell) {
      data.items.forEach(item => {
        if (updateData.updates[item.key] !== item.key) {
          updateData.updates[item.key] = 0;
        }
      });
    }
  }

  await updateCart(updateData)
}

async function getCart() {
  try {
    const response = await fetch(`${theme.routes.cart_url}.json`)
    return await response.json()
  } catch (error) {
    console.error('An error occurred while fetching the cart:', error)
  }
}

async function updateCart(updateData) {
  const body = JSON.stringify(updateData)
  try {
    const response = await fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{body}})
    const responseData = await response.json()
    await window.refreshCart(responseData);
  } catch (error) {
    $cart.classList.remove('is-loading');
    console.error('An error occurred while modifying the cart:', error)
  }
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {'Content-Type': 'application/json', 'Accept': `application/${type}`}
  };
}

// Upsell add to cart
let upsellAddButtons = document.querySelectorAll('.cart-upsell__add-btn');
upsellAddButtons.forEach(function (button) {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    let variantId = button.closest('.cart-upsell__actions').querySelector('[name="variant_id"]').value;
    let formData = {
      "items": [{
        "id": variantId,
        "properties": {
          "_upsell": true
        },
        "quantity": 1
      }]
    };
    document.dispatchEvent(new CustomEvent("cart:add", {
      detail: {
        data: formData
      }
    }));
  });
});

// Upsell selector
document.querySelectorAll('.cart-upsell .cc-select__option').forEach(function (option) {
  option.addEventListener('click', function () {
    let variantId = option.getAttribute('data-variant-id');
    option.closest('.cart-upsell__actions').querySelector('input[name="variant_id"]').value = variantId;

    // Handle image change
    option.closest('.cart-upsell__item').querySelectorAll('.cart-upsell__image').forEach(function (image) {
      image.style.display = "none";
    });
    option.closest('.cart-upsell__item').querySelector(`.cart-upsell__image[data-variant-id="${variantId}"]`).style.display = "block";

    // Handle button state when sold out
    if (option.classList.contains('sold-out')) {
      option.closest('.cart-upsell__actions').querySelector('.cart-upsell__add-btn').classList.add('cart-upsell__add-btn--soldout');
    } else {
      option.closest('.cart-upsell__actions').querySelector('.cart-upsell__add-btn').classList.remove('cart-upsell__add-btn--soldout');
    }
  });
});

// Re-render the cart
window.refreshCart = async function (data) {
  console.log('data', data);
  let cartHtml = data.sections['cart-drawer'];
  let cartBarContainer = document.querySelector('#shopify-section-cart-drawer .cart-bar');
  let cartListContainer = document.querySelector('#shopify-section-cart-drawer .cart-drawer__content');
  let cartFooterContainer = document.querySelector('#shopify-section-cart-drawer .cart-drawer__footer');
  let customShippingBar = document.querySelector(".custom-ss-bar-t");
  cartListContainer.innerHTML = ""; // Empty the cart content
  cartFooterContainer.innerHTML = ""; // Empty the cart footer content
 
  if(cartBarContainer){
    cartBarContainer.innerHTML = ""; // Empty the cart bar content
  }
 
 
  let template = document.createElement("div");
  template.innerHTML = cartHtml;
   if(customShippingBar && template.querySelector(".custom-ss-bar-t") ){
     customShippingBar.innerHTML = template.querySelector(".custom-ss-bar-t").innerHTML;  
     
  }
  let cartBarContents = template.querySelectorAll('#shopify-section-cart-drawer .cart-bar > *'); // Get the new content of the cart
  // Hide upsell container if cart is empty
  if (data.items && data.items.length === 0) {
    document.querySelector(".cart-upsell").classList.add("hide");
    document.querySelector(".shipping-progress-bar")?.classList.add("hide");
  } else {
    document.querySelector(".cart-upsell").classList.remove("hide");
    document.querySelector(".shipping-progress-bar")?.classList.remove("hide");
  }
  if(cartBarContents.length > 0){
     // Add the new content in the cart
  cartBarContents.forEach(function (content) {
    cartBarContainer.append(content);
  });

  }
  

  

  let cartListContents = template.querySelectorAll('#shopify-section-cart-drawer .cart-drawer__content > *'); // Get the new content of the cart
    let cartFooterContents = template.querySelectorAll('#shopify-section-cart-drawer .cart-drawer__footer > *');

  if(cartListContents.length > 0){
    // Add the new content in the cart
    cartListContents.forEach(function (content) {
      cartListContainer.append(content);
    });
  }
  
if(cartFooterContents.length > 0){
  
  // Add the new content in the cart
  cartFooterContents.forEach(function (content) {
    cartFooterContainer.append(content);
  });

}
  // Get cart infos and update quantity in header
  let cart = await getCart();
  document.querySelector('.cart-drawer__count span').innerHTML = cart.item_count;

  // Count in header
  let headerCount = document.querySelector(cart_count);
  headerCount.innerHTML = cart.item_count;
  headerCount.style.display = cart.item_count == 0 ? "none" : "block";

  // Remove loading states
  $cart.classList.remove('is-loading');
  document.querySelectorAll('form[action$="/cart/add"] button[type="submit"]').forEach(function (elem) {
    elem.classList.remove('is-loading');
  });
  document.dispatchEvent(new CustomEvent("cart_drawer:updated", {
      detail: {
        cart: cart
      }
    }));
  bindEvents();
  refreshUpsellSlider();
};

// Open the cart
function openCart() {
  $cart.classList.add('is-active');
  $overlay.classList.add('is-active');
  $body.classList.add('no-scroll');
}

// Close the cart
function closeCart() {
  $cart.classList.remove('is-active');
  $overlay.classList.remove('is-active');
  $body.classList.remove('no-scroll');
}